<h1 mat-dialog-title>Place</h1>
<mat-dialog-content>
    <mat-tab-group mat-align-tabs="start" class="detail-component">
        <mat-tab label="Data">
            <div fxLayout="column" fxLayoutGap="10px">
                <mat-form-field fxFlex>
                    <mat-label i18n="@@title">Title</mat-label>
                    <input matInput i18n-placeholder placeholder="e.g. Alsweder" [(ngModel)]="data.title" required />
                </mat-form-field>
            
                <mat-form-field fxFlex>
                    <mat-label i18n="@@description">Description</mat-label>
                    <input matInput i18n-placeholder placeholder="e.g. Church" [(ngModel)]="data.description"
                        required />
                </mat-form-field>
            
                <mat-form-field fxFlex>
                    <mat-label i18n="@@shorthandSymbol">Shorthand Symbol</mat-label>
                    <input matInput i18n-placeholder placeholder="e.g. AL"
                        [(ngModel)]="data.shorthandSymbol" required />
                </mat-form-field>
            
                <mat-form-field fxFlex>
                    <mat-label i18n="@@address">Address</mat-label>
                    <textarea matInput i18n-placeholder placeholder="e.g. Alswederlandstraße 2, 32339 Espelkamp" [(ngModel)]="data.address"></textarea>
                </mat-form-field>
            </div>
        </mat-tab>
        <mat-tab label="History" *ngIf="isEditDialog">
            <app-table-detail-history class="detail-tab" entityName="places" [entityId]="data._id">
            </app-table-detail-history>
        </mat-tab>
        <mat-tab label="General" *ngIf="isEditDialog">
            <app-table-detail-abstract class="detail-tab" [data]="data"></app-table-detail-abstract>
        </mat-tab>
    </mat-tab-group>
</mat-dialog-content>
<div mat-dialog-actions align="end">
    <button mat-button [disabled]="inProgress" (click)="abort()">Abort</button>
    <button mat-button [disabled]="inProgress" (click)="save()" cdkFocusInitial>Ok</button>
</div>
